
import React from 'react';
import { Case } from '../../../../models/SelmaModels';
import { AppComponent } from '../../../AppComponent';
import { StepHeader } from '../../StepHeader';
import { StepContext } from '../../CaseSteps';
import { THtml } from '../../../widget/display/THtml';
import { FormUnit, FormUnitSize } from '../../../layout/FormUnit/FormUnit';
import { Heading } from '../../../widget/display/Heading/Heading';
import { RequestedAttachments } from '../StepBudget/RequestedAttachments';
import { ProvidedAttachments } from '../StepBudget/ProvidedAttachments';
import { Button } from '../../../widget/input/Button/Button';
import { ButtonGroup, ButtonGroupLayout } from '../../../widget/input/ButtonGroup/ButtonGroup';
import { StepFooter } from '../../StepFooter';

interface Props {
	case: Case;
	context: StepContext;
}

export class StepDone extends AppComponent<Props> {
	constructor(props: Props) {
		super(props);
	}

	componentDidMount() {
		const attachmentService = this.application.services.attachmentService;

		const c = this.props.case;
		this.observeUpdate(c);
		
		attachmentService.ensureCorrectAttachmentRequests(c);
	}

	goHome = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
		this.props.context.goHome();
	}

	goPrev = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
		this.props.context.goPrev();
	}


	render() {
		const c = this.props.case;
		const attachmentService = this.application.services.attachmentService;

		let attachmentRequests = c.attachmentRequests;
		let attachments = c.attachments||[];
		const filterOutBudget = attachmentService.getAttachmentsByType(c, 'COMPANYBUDGET').length>0;
		if( filterOutBudget ) {
			attachmentRequests = attachmentService.filterOutAttachmentRequestsByRequestType(attachmentRequests, 'COMPANYBUDGET');
			attachments = attachmentService.filterOutAttachmentsByRequestType(attachments, 'COMPANYBUDGET')||[];
		}

		return (
			<div className="StepDone Step">
				<StepHeader  context={this.props.context}
					titleTextkey="Done_Title" descriptionTextkey="Done_Description" />

				<FormUnit size={FormUnitSize.Large}>
					<Heading level={2} labelTextkey="Done_Complement_Title"/>
					<p>
						<THtml k="Done_Complement_Description"/>
					</p>
					<p>
						<THtml k="Done_Complement_Documents"/>
					</p>
					
					{attachmentRequests && attachmentRequests.length>0 && 
						<> 
						<br/>
						<Heading level={2} labelTextkey="Done_Complement_RequestedAttachments"/>
						<RequestedAttachments case={c} attachmentRequests={attachmentRequests} attachments={attachments}/>
						{/* attachments && attachments.length>0 &&
							<>
							<br/>
							<Heading level={3} labelTextkey="Done_Complement_Attachments"/>
							<ProvidedAttachments case={c} attachments={attachments} allowDelete={true}/>
							</>
						*/}
						</>
					}
					<br/>
				</FormUnit>

				<FormUnit size={FormUnitSize.Large}>
					<p>
						<THtml k="Done_Last_Description"/>
					</p>
					<ButtonGroup layout={ButtonGroupLayout.Stretch}>
						<Button
							id="goPrev"
							className="Button outline big green"
							labelTextkey="Summary_Title"
							onClick={this.goPrev}
						/>
						<Button
							id="goHome"
							className="Button big green"
							labelTextkey="Done_Home_Link"
							onClick={this.goHome}
						/>
					</ButtonGroup>
				</FormUnit>

				{/* <StepFooter
					context={this.props.context}
					canGoHome={true}
					canGoToNext={false}
					onGoHome={this.props.context.goHome}
					onGoToNext={this.props.context.goNext}
				/> */}
			</div>
		);
	}

}
